// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"7e9f3946","453":"18ae9115","457":"0cad1d6b","484":"a907d451","551":"98952170","869":"51db3946","974":"9229ebc3"}[chunkId] + ".chunk.js";
};